// src/i18n/translations.js
export const translations = {
  en: {
    app: {
      title: 'VAT Calculator',
      subtitle: 'Enter any amount — results update instantly',
    },
    rate: { label: 'VAT Rate' },
    field: { net: 'Net amount (excl. VAT)', gross: 'Gross amount (incl. VAT)' },
    results: {
      label: 'Breakdown',
      net: 'Net amount (HT)',
      vat: 'VAT amount',
      gross: 'Gross amount (TTC)',
    },
    badge: { applied: (rate) => `${rate}% VAT applied` },
    install: { button: 'Install app' },
    copy: { success: 'Copied!' },
  },
  fr: {
    app: {
      title: 'Calculateur TVA',
      subtitle: 'Entrez un montant — les résultats se mettent à jour instantanément',
    },
    rate: { label: 'Taux TVA' },
    field: { net: 'Montant HT (hors TVA)', gross: 'Montant TTC (avec TVA)' },
    results: {
      label: 'Détail',
      net: 'Montant HT',
      vat: 'Montant TVA',
      gross: 'Montant TTC',
    },
    badge: { applied: (rate) => `TVA ${rate}% appliquée` },
    install: { button: "Installer l'app" },
    copy: { success: 'Copié !' },
  },
  ar: {
    app: {
      title: 'حاسبة الضريبة',
      subtitle: 'أدخل أي مبلغ — تُحدَّث النتائج فوراً',
    },
    rate: { label: 'نسبة الضريبة' },
    field: { net: 'المبلغ بدون ضريبة', gross: 'المبلغ مع الضريبة' },
    results: {
      label: 'التفاصيل',
      net: 'المبلغ بدون ضريبة',
      vat: 'مبلغ الضريبة',
      gross: 'المبلغ مع الضريبة',
    },
    badge: { applied: (rate) => `ضريبة ${rate}% مطبقة` },
    install: { button: 'تثبيت التطبيق' },
    copy: { success: 'تم النسخ!' },
  },
  es: {
    app: {
      title: 'Calculadora IVA',
      subtitle: 'Introduce cualquier importe — los resultados se actualizan al instante',
    },
    rate: { label: 'Tasa IVA' },
    field: { net: 'Importe neto (sin IVA)', gross: 'Importe bruto (con IVA)' },
    results: {
      label: 'Desglose',
      net: 'Importe neto',
      vat: 'Importe IVA',
      gross: 'Importe bruto',
    },
    badge: { applied: (rate) => `IVA ${rate}% aplicado` },
    install: { button: 'Instalar app' },
    copy: { success: '¡Copiado!' },
  },
  de: {
    app: {
      title: 'MwSt-Rechner',
      subtitle: 'Beliebigen Betrag eingeben — Ergebnisse werden sofort aktualisiert',
    },
    rate: { label: 'MwSt-Satz' },
    field: { net: 'Nettobetrag (ohne MwSt)', gross: 'Bruttobetrag (mit MwSt)' },
    results: {
      label: 'Aufschlüsselung',
      net: 'Nettobetrag',
      vat: 'MwSt-Betrag',
      gross: 'Bruttobetrag',
    },
    badge: { applied: (rate) => `${rate}% MwSt angewendet` },
    install: { button: 'App installieren' },
    copy: { success: 'Kopiert!' },
  },
};
